<template>
  <div class="search-form-box main-card whaty-grid-search-form" :class="[!showSearchForm ? 'search-fold-all' : 'search-fold-part']" ref="mSearchDiv">
    <div v-show="showSearchMask" class="mSearch-mask" title="禁用，请先取消选择全部"></div>
    <el-scrollbar v-show="showSearchForm" class="whaty-search-scroll" ref="whatySearchScroll" wrap-class="whaty-scroll-wrap" :style="{'height': searchFormHeight + 'px'}">
    <div v-show="showSearchForm" class="mSearch-form-group" ref="searchForm" @keydown.enter="handleSearch">
      <ul class="clearfix">
        <li
          v-for="item in gridConfig.listColumnConfig"
          v-if="item.search && item.type !== 'file' && !(hideFlag && item['_hide'])"
          class="search-cell">
          <div class="form-row">
            <div class="form-con">
              <el-tooltip class="item" effect="dark" :content="contentMap[item.dataIndex]" placement="top" :open-delay="800" :enterable="false">
                <div class="input-wrap">

                  <whaty-search-input-text
                    v-if="(item.type === 'text' || item.type === 'textArea')"
                    v-model="searchParams[item.dataIndex]"
                    :dataIndex="item.dataIndex"
                    :gridConfig="gridConfig"
                    :gridConfigUrl="gridConfigUrl"
                    :placeholder="item.name"
                  ></whaty-search-input-text>

                  <whaty-search-input-number
                    v-if="item.type === 'number'"
                    v-model="searchParams[item.dataIndex]"
                    :dataIndex="item.dataIndex"
                    :gridConfig="gridConfig"
                    :gridConfigUrl="gridConfigUrl"
                    :placeholder="item.name"
                  ></whaty-search-input-number>

                  <whaty-search-select
                    :ref="selectRefPrefix + item.uid"
                    v-if="item.type === 'select' || item.type === 'single_select'"
                    v-model="searchParams[item.dataIndex]"
                    :searchParams="searchParams"
                    :fatherDataList="selectDataList"
                    :noDateText="selectNoDataTextMap[item.uid]"
                    :gridConfig="gridConfig"
                    :gridConfigUrl="gridConfigUrl"
                    :dataParameter="item"
                    :selectType="item.type"
                    @select-data-change="handleWhatySelectDataChange($event, item)"
                    @change="handleSelectChange(item)"
                    @content-value="contentData($event, item)"
                  >
                  </whaty-search-select>

                  <whaty-select
                    v-if="item.type === 'remote_select'"
                    v-model="searchParams[item.dataIndex]"
                    :url="remoteSelectDataUrl"
                    :queryParams="getSelectQueryParams(item)"
                    :placeholder="item.name"
                    :valueIndex="1"
                    @select-data-change="handleWhatySelectDataChange($event, item)"
                    @change="handleSelectChange(item)"
                  >
                  </whaty-select>

                  <whaty-cascader
                    :placeholder="item.name"
                    :options="cascadeSelectDataList[item.uid]"
                    :ref="selectRefPrefix + item.uid"
                    :loading="!!selectLoadingMap[item.uid]"
                    :no-data-text="selectNoDataTextMap[item.uid] || '无数据'"
                    v-if="item.type === 'cascade_select'"
                    v-model.trim="searchParams[item.searchColumnIndex]"
                    collapse-tags
                    :props="loadCascadeConfig(item)"
                    size="mini" filterable clearable
                    @focus="handleSelectFocus(item)"
                    @change="handleSelectChange(item)"
                  >
                  </whaty-cascader>
                  <div  v-if="(item.type === 'date'|| item.type === 'datetime')">
                  <whaty-search-date-picker
                    v-model="searchParams[item.dataIndex]"
                    :placeholder="item.name"
                    :dateType="item.type"
                    @content-value="contentData($event, item)"
                    size="mini"
                    :key="datePicker">
                  </whaty-search-date-picker>
                  </div>
<!--                  <el-date-picker-->
<!--                    v-if="item.type === 'datetime'"-->
<!--                    v-model="searchParams[item.dataIndex]"-->
<!--                    type="datetimerange"-->
<!--                    align="right"-->
<!--                    unlink-panels-->
<!--                    range-separator="至"-->
<!--                    :start-placeholder="item.name"-->
<!--                    :end-placeholder="item.name"-->
<!--                    :picker-options="pickerOptions"-->
<!--                    format="yyyy-MM-dd HH:mm:ss"-->
<!--                    value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                    size="mini"-->
<!--                    popper-class="whaty-el-date-picker"-->
<!--                  >-->
<!--                  </el-date-picker>-->

                </div>
              </el-tooltip>
            </div>
          </div>
        </li>
      </ul>
    </div>
    </el-scrollbar>
    <div v-show="showSearchForm" class="search-submit-area">
      <div class="guide-btn" @click.prevent="searchGuide">
        <a href="javascript:"><i class="mng icon-question-stroke"></i><span>搜索引导</span></a>
      </div>
      <a @click="handleShowSaveSearchGroupDialog" href="javascript:" ondragstart="return false" class="btn btn-anti-primary">保存搜索条件</a>
      <div class="mSearch-filter">
        <el-select
          @focus.once="handleSearchGroupSelectFocus($event)"
          @visible-change="closeSearchGroupDropSubmenu"
          @change="handleSearchGroupChange"
          @clear="handleSearchGroupClear"
          :title="selectTitle"
          v-model="selectedSavedSearchParams" placeholder="我的查询" size="mini" filterable clearable popper-class="search-select drop-form">
          <el-option
            v-for="item in userGridConfigList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :title="item.name">
            <a href="javascript:" class="drop-link" :class="{'drop-select': item.id === dropLinkSelect.id}">
              <span class="drop-txt">{{ item.name }}</span>
              <i @click.stop="showSearchGroupDrop(item, $event)" style="margin-top: -16px" class="mng icon-moreDots drop-ico-suf drop-ico-more"></i>
            </a>
          </el-option>
        </el-select>
        <div
          v-show="showDropSubmenu"
          :style="[{'left': dropSubmenuLeft + 'px'}, {'top': dropSubmenuTop + 'px'}]"
          class="drop drop-submenu">
          <ul>
            <li @click="handleShowUpdateSearchGroupDialog" class="drop-list"><a href="javascript:" class="drop-link">修改名称</a></li>
            <li @click="deleteSearchGroup" class="drop-list"><a href="javascript:" class="drop-link">删除</a></li>
          </ul>
        </div>
      </div>
      <a @click="handleSearch" href="javascript:" ondragstart="return false" class="btn btn-solid-primary">搜索</a>
      <a @click="clearSearchForm" href="javascript:" ondragstart="return false" class="btn btn-anti-default">重置</a>
    </div>

    <whaty-dialog v-if="showSearchForm" :title="searchGroupSaveOrUpdateFlag === 1 ? '保存筛选名称' : '修改筛选名称'"
                  :visible.sync="showSaveSearchGroupDialog" width="480px"
                  :append-to-body="true"
                  @yes-btn-click="handleSearchGroupFormSubmit">
      <div class="popup-content-in">
        <div class="clearfix popup-content-in">
          <div class="form-table-wrap">
            <div class="form-table-head"><span>名称</span></div>
            <div class="form-table-body">
              <el-input
                v-model.trim="searchGroupInputValue"
                placeholder="请输入名称">
              </el-input>
            </div>
          </div>
        </div>
      </div>
    </whaty-dialog>

    <div class="search-fold-foot" @click="handleShowOrHideIcon">
      <el-dropdown :popper-append-to-body="false" @command="handleShowOrHide" :show-timeout="300">
        <a class="search-fold-btn el-dropdown-link" href="javascript:;"><i class="mng" :class="{'icon-fold-down': !hideFlag, 'icon-fold-updown': hideFlag}"></i></a>
          <ul>
            <el-dropdown-menu slot="dropdown" class="search-fold-dropdown">
              <el-dropdown-item v-if="showSearchForm && !hideFlag && showHideBtn" class="drop-list" command="1">
                <a href="javascript:;" style="padding: 0" class="drop-link"><span class="drop-txt">收起部分</span></a>
              </el-dropdown-item>
              <el-dropdown-item v-if="!showSearchForm && showHideBtn" class="drop-list" command="2">
                <a href="javascript:;" style="padding: 0" class="drop-link"><span class="drop-txt">展开部分</span></a>
              </el-dropdown-item>
              <el-dropdown-item v-if="showSearchForm" class="drop-list" command="3">
                <a href="javascript:;" style="padding: 0" class="drop-link"><span class="drop-txt">收起全部</span></a>
              </el-dropdown-item>
              <el-dropdown-item v-if="!showSearchForm || hideFlag" class="drop-list" command="4">
                <a href="javascript:;" style="padding: 0" class="drop-link"><span class="drop-txt">展开全部</span></a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </ul>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import util from '../../libs/util'
  import {ELEMENT_DATE_PICKER_OPTIONS_1} from '../../libs/constants'
  import WhatyDialog from '../dialog/dialog.vue'
  import WhatySelect from '../whaty-select/whaty-select'
  import WhatyCascader from './whaty-cascader'
  import WhatySearchInputText from '../whaty-search-input-text/index'
  import WhatySearchInputNumber from '../whaty-search-input-number/index'
  import WhatySearchDatePicker from '../whaty-search-date-picker/index'
  import WhatySearchSelect from '../whaty-search-select/index'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    components: {
      WhatyCascader,
      WhatySearchSelect,
      WhatySearchDatePicker,
      WhatySearchInputNumber,
      WhatySearchInputText,
      WhatySelect,
      WhatyDialog
    },
    name: 'grid-search-form',
    props: {
      gridConfig: { // grid配置
        type: Object,
        default() {
          return {}
        }
      },
      gridConfigUrl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        hideLine: 1, // 隐藏行数
        showHideBtn: false, // 显示隐藏部分按钮
        hideFlag: false, // 隐藏部分标识
        showSearchForm: true,
        selectLoadingMap: {}, // select字段的loading状态
        selectNoDataTextMap: {}, // select字段无匹配数据时的提示文本
        selectLoadStatusMap: {}, // select字段是否load标识
        showDropSubmenu: false, // 是否显示搜索组的子菜单
        dropLinkSelect: {}, // 当前显示了子菜单的搜索条件组
        dropSubmenuLeft: 0,
        dropSubmenuTop: 0,
        cascadeSearchLabels: {}, // 级联选择器选中值label储存对象
        searchParams: {}, // 搜索区域绑定的搜索参数
        selectDataList: {}, // 下拉框数据储存对象
        pickerOptions: ELEMENT_DATE_PICKER_OPTIONS_1, // 日期选择框快捷操作配置
        showSaveSearchGroupDialog: false, // 是否显示保存搜索条件的dialog
        searchGroupInputValue: '', // 搜索条件组保存框中input的value
        selectedSavedSearchParams: '', // 当前选择的搜索条件组
        userGridConfigList: [], // 用户的搜索条件组
        searchGroupSaveOrUpdateFlag: 1, // 保存/更新 搜索条件组标识，1：保存，2：更新
        showSearchMask: false, // 是否显示搜索区域的遮罩
        selectRefPrefix: 'search-select-',
        contentMap: {}, // content提示Map
        // 级联选择器数据储存对象
        cascadeSelectDataList: {},
        // 级联选择器属性储存对象
        cascadeSelectPropList: {},
        // 级联选择器默认配置
        defaultCascadeConfig: {
          // 指定选项的值为选项对象的某个属性值
          label: 'name',
          // 指定选项标签为选项对象的某个属性值
          value: 'id',
          // 在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
          emitPath: false,
          // 是否多选
          multiple: false,
          // 是否严格的遵守父子节点不互相关联
          checkStrictly: true
        },
        datePicker: '', // 时间组件，用于重置
        selectTitle: '', // title显示
        searchFormHeight: 40
      }
    },
    computed: {
      selectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData')
      },
      cascadeSelectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'cascadeSelectData')
      },
      remoteSelectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData/search')
      },
      saveUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'saveUserGridConfig')
      },
      updateUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'updateUserGridConfig')
      },
      deleteUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'deleteUserGridConfig')
      },
      queryUserGridConfigUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'queryUserGridConfig')
      },
      uidColumnMap: function () {
        let map = {}
        if (this.gridConfig.listColumnConfig && this.gridConfig.listColumnConfig.length > 0) {
          this.gridConfig.listColumnConfig.forEach(item => {
            map[item.uid] = item
          })
        }
        return map
      },
      queryParams: function () {
        return this.$route.query
      }
    },
    mounted() {
      if (!this.gridConfig.flagShowAllSearch) {
        this.calculateHide()
      }
      addResizeListener(this.$refs.mSearchDiv, this.calculateHideCol)
      this.searchFormAutoHeight()
    },
    beforeDestroy() {
      removeResizeListener(this.$refs.mSearchDiv, this.calculateHideCol)
    },
    created() {
      this.gridConfig.listColumnConfig.forEach(item => {
        this.$set(this.contentMap, item.dataIndex, item.name)
      })
    },
    methods: {
      getSelectQueryParams(item) {
        return {
          ...this.queryParams,
          actionId: this.gridConfig.gridId,
          columnDataIndex: item.dataIndex
        }
      },
      handleSelectFocus(item) {
        if (item.selectData) { // 本地加载数据
          this.$set(this.selectDataList, item.uid, item.selectData)
        } else { // 远程加载数据
          if (!this.selectLoadStatusMap[item.uid]) {
            // 判断dependColumns是否有值
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnName = ''
              item.dependColumns.forEach(uid => {
                let column = this.uidColumnMap[uid]
                let key = column.dataIndex
                let value = this.searchParams[key]
                if (!value) {
                  if (dependColumnName) {
                    dependColumnName += '、'
                  }
                  dependColumnName += column.name
                }
              })
              if (dependColumnName) {
                this.$set(this.selectNoDataTextMap, item.uid, '请先选择：' + dependColumnName)
                return
              } else {
                this.$set(this.selectNoDataTextMap, item.uid, '无数据')
              }
            }
            // 设置为select状态为加载中
            this.$set(this.selectLoadingMap, item.uid, true)
            let params = this.getSelectQueryParams(item)
            // 补充级联参数
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnValues = {}
              item.dependColumns.forEach(uid => {
                let key = this.uidColumnMap[uid].dataIndex
                let value = this.searchParams[key]
                if (value) {
                  let sd = this.selectDataList[this.uidColumnMap[uid].uid]
                  if (sd) {
                    for (let i = 0; i < sd.length; i++) {
                      if (sd[i][1] === value) {
                        value = sd[i][0]
                        break
                      }
                    }
                    dependColumnValues[this.uidColumnMap[uid].dataIndex_] = value
                  }
                }
              })
              params.dependColumnValues = dependColumnValues
            }
            let cascadeConfig = {...this.cascadeSelectPropList[item.id]}
            let isCascade = item.type === 'cascade_select'
            let url = isCascade ? (cascadeConfig.dataUrl || this.cascadeSelectDataUrl) : (item.selectDataUrl || this.selectDataUrl)
            util.ajax.post(url, {params}).then((res) => {
              if (res.data.meta.errCode === 0) {
                if (isCascade) {
                  this.$set(this.cascadeSelectDataList, item.uid, res.data.data)
                } else {
                  this.$set(this.selectDataList, item.uid, res.data.data)
                }
              } else {
                this.$notify.error({title: '错误', message: res.data.data})
              }
              this.$set(this.selectLoadingMap, item.uid, false)
            }).catch(() => {
              this.$set(this.selectLoadingMap, item.uid, false)
              console.error('获取数据失败！ ' + item.name)
            })
            this.selectLoadStatusMap[item.uid] = true
          }
        }
      },
      setNodeLabel(item) {
        let selectNodesComponent = this.$refs[this.selectRefPrefix + item.uid][0]
        let selectNodeLabels = []
        // 多选时从checkedNodes中取值，单选时从presentText中取值
        if (selectNodesComponent.multiple) {
          let checkedNodes = selectNodesComponent.checkedNodes ? selectNodesComponent.checkedNodes : []
          for (let i = 0; i < checkedNodes.length; i++) {
            selectNodeLabels[i] = checkedNodes[i].label
          }
        } else {
          selectNodeLabels[0] = selectNodesComponent.presentText
        }
        this.$set(this.cascadeSearchLabels, item.searchColumnIndex, selectNodeLabels)
      },
      // select的change事件监听
      handleSelectChange(item) {
        if (item.type === 'cascade_select') {
          // 延迟记录级联勾选后记下label的值，结果高亮处理要用
          setTimeout(this.setNodeLabel, 100, item)
        }
        // select变化时将它影响的其他select的值置空
        if (item.cascadeColumns && item.cascadeColumns.length > 0) {
          item.cascadeColumns.forEach(uid => {
            if (this.$refs[this.selectRefPrefix + uid] && this.$refs[this.selectRefPrefix + uid][0] && this.uidColumnMap[uid]) {
              // clear form field data
              this.$set(this.searchParams, this.uidColumnMap[uid].dataIndex, '')
              // reset field select data
              this.$set(this.selectDataList, uid, [])
              // reset field load status
              this.selectLoadStatusMap[uid] = false
            }
          })
        }
      },
      handleWhatySelectDataChange(selectData, item) {
        this.$set(this.selectDataList, item.uid, selectData)
      },
      clearSearchForm() { // 清空search form
        this.selectTitle = ''
        this.searchParams = {}
        this.selectedSavedSearchParams = ''
        this.datePicker = new Date().getTime()
        this.gridConfig.listColumnConfig.forEach(item => {
          this.$set(this.contentMap, item.dataIndex, item.name)
        })
//        for (let key in this.searchParams) {
//          if (util.isArray(this.searchParams[key])) {
//            this.$set(this.searchParams, key, [])
//          } else {
//            this.$delete(this.searchParams, key)
//          }
//        }
      },
      handleSearch(e) { // 搜索
        // 判断keyCode === 13，目的是避免IE11中——中文输入法回车键入英文字母触发的事件
        if (e.type === 'click' || e.keyCode === 13) {
          this.$emit('on-search')
        }
      },
      handleShowAdvancedSearchForm() { // 搜索
        this.$emit('show-advanced-search')
      },
      handleShowSaveSearchGroupDialog() { // 保存搜索条件
        this.searchGroupSaveOrUpdateFlag = 1
        this.searchGroupInputValue = ''
        this.showSaveSearchGroupDialog = true
      },
      handleSearchGroupFormSubmit() { // 保存搜索条件组form submit event
        if (this.searchGroupSaveOrUpdateFlag === 1) {
          this.saveSearchGroup()
        } else {
          this.updateSearchGroup()
        }
        this.selectTitle = this.searchGroupInputValue
      },
      saveSearchGroup() { // 保存搜索条件
        let gridId = this.gridConfig.gridId || ''
        let userGridConfigName = this.searchGroupInputValue
        let searchParams = JSON.stringify(this.searchParams)
        let dataList = {}
        // 保存需要用到的数据信息
        for (let dataKey in this.selectDataList) {
          for (let idKey in this.selectDataList[dataKey]) {
            for (let searchKey in this.searchParams) {
              // 防止日期范围报错 判断是否为string
              if (typeof this.searchParams[searchKey] === 'string') {
                let searchContent = this.searchParams[searchKey].replace(/= /g, '').split(' or ')
                for (let i = 0; i < searchContent.length; i++) {
                  let dataContent = this.selectDataList[dataKey][idKey][1]
                  if (searchContent[i] === dataContent) {
                    if (dataList[dataKey]) {
                      let dataArray = dataList[dataKey]
                      dataArray.push(this.selectDataList[dataKey][idKey])
                      this.$set(dataList, dataKey, dataArray)
                    } else {
                      let dataArray = []
                      dataArray.push(this.selectDataList[dataKey][idKey])
                      this.$set(dataList, dataKey, dataArray)
                    }
                  }
                }
              }
            }
          }
        }
        // 处理保存数据为时间范围类型
        for (let searchKey in this.searchParams) {
          if (this.searchParams[searchKey] instanceof Array &&
              this.searchParams[searchKey][0] instanceof Date &&
              this.searchParams[searchKey][1] instanceof Date) {
            let startDateStr = JSON.stringify(this.searchParams[searchKey][0])
            startDateStr = startDateStr.slice(1, -1)
            let endDateStr = JSON.stringify(this.searchParams[searchKey][1])
            endDateStr = endDateStr.slice(1, -1)
            searchParams = searchParams.replace(startDateStr, util.formatDate(this.searchParams[searchKey][0], 'yyyy-MM-dd HH:mm:ss'))
            searchParams = searchParams.replace(endDateStr, util.formatDate(this.searchParams[searchKey][1], 'yyyy-MM-dd HH:mm:ss'))
          }
        }
        let searchList = (searchParams.replace(/= /, '')).split(' or ')
        for (let i = 0; i < searchList.length; i++) {

        }
        let selectDataList = JSON.stringify(dataList)
        searchParams = searchParams + '||' + selectDataList
        if (userGridConfigName === '') {
          this.$notify.warning({title: '警告', message: '请输入名称！'})
          return
        }
        if (userGridConfigName.length > 30) {
          this.$notify.warning({title: '警告', message: '名称最长30个字符！'})
          return
        }
        let params = {}
        params.params = {
          gridId: gridId,
          gridUrl: this.gridConfigUrl,
          userGridConfigName: userGridConfigName,
          searchConfig: searchParams,
          type: 0
        }
        util.ajax.post(this.saveUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功！'})
            this.handleSearchGroupSelectFocus()
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '保存失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      },
      updateSearchGroup() { // 更新搜索条件
        let configId = this.dropLinkSelect.id
        let userGridConfigName = this.searchGroupInputValue
        if (userGridConfigName === '') {
          this.$notify.warning({title: '警告', message: '请输入名称！'})
          return
        }
        if (userGridConfigName.length > 30) {
          this.$notify.warning({title: '警告', message: '名称最长30个字符！'})
          return
        }
        let params = {}
        params.params = {
          configId: configId,
          userGridConfigName: userGridConfigName
        }
        util.ajax.post(this.updateUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '修改成功！'})
            this.handleSearchGroupSelectFocus()
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '修改失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      },
      showSearchGroupDrop(item, e) { // 显示搜索条件组的操作按钮
        this.dropLinkSelect = item
        this.showDropSubmenu = true
        this.dropSubmenuLeft = e.pageX - 10
        this.dropSubmenuTop = e.pageY + 10
      },
      handleSearchGroupSelectFocus(e) { // 加载搜索条件组下拉数据
        let ph = e ? e.target.placeholder : ''
        if (e) {
          e.target.placeholder = '请稍等，数据加载中...'
        }
        let params = {
          actionId: this.gridConfig.gridId,
          gridUrl: this.gridConfigUrl,
          type: 0
        }
        util.ajax.post(this.queryUserGridConfigUrl, {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.userGridConfigList = res.data.data
          }
          if (e) {
            e.target.placeholder = ph
          }
        }).catch((err) => {
          console.warn('获取用户搜索条件组失败！')
          console.error(err)
          if (e) {
            e.target.placeholder = ph
          }
        })
      },
      closeSearchGroupDropSubmenu(flag) { // 关闭显示的search group drop submenu
        if (flag) {
          this.dropLinkSelect = {}
        } else {
          this.showDropSubmenu = false
        }
      },
      handleSearchGroupChange(searchGroupId) { // 搜索条件组选中值发生变化时触发
        let reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/
        let regExp = new RegExp(reg)
        for (let i = 0; i < this.userGridConfigList.length; i++) {
          if (this.userGridConfigList[i].id === searchGroupId) {
            this.selectTitle = this.userGridConfigList[i].name
            this.searchParams = JSON.parse(this.userGridConfigList[i].searchConfig.split('||')[0])
            if (this.userGridConfigList[i].searchConfig.split('||')[1]) {
              this.selectDataList = JSON.parse(this.userGridConfigList[i].searchConfig.split('||')[1], function (key, value) {
                if (regExp.test(value)) {
                  return new Date(value)
                } else {
                  return value
                }
              })
            }
            break
          }
        }
      },
      handleSearchGroupClear() {
        this.selectTitle = ''
      },
      handleShowUpdateSearchGroupDialog() {
        this.searchGroupSaveOrUpdateFlag = 2
        this.searchGroupInputValue = this.dropLinkSelect.name
        this.showSaveSearchGroupDialog = true
      },
      deleteSearchGroup() {
        let params = {}
        params.params = {configId: this.dropLinkSelect.id}
        util.ajax.post(this.deleteUserGridConfigUrl, params).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '删除成功！'})
            this.handleSearchGroupSelectFocus()
          }
          if (this.selectedSavedSearchParams === this.dropLinkSelect.id) {
            this.selectedSavedSearchParams = ''
          }
          this.showSaveSearchGroupDialog = false
          this.searchGroupInputValue = ''
          this.selectTitle = ''
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '删除失败'})
          console.error(err)
          this.showSaveSearchGroupDialog = false
        })
      },
      loadCascadeConfig(item) {
        let cascadeConfig = {}
        if (item.extendColumnConfig) {
          let extendColumnConfig = JSON.parse(item.extendColumnConfig)
          if (extendColumnConfig.searchConfig) {
            cascadeConfig = {...extendColumnConfig.searchConfig}
          } else if (extendColumnConfig.defaultConfig) {
            cascadeConfig = {...extendColumnConfig.defaultConfig}
          }
        }
        cascadeConfig = Object.assign({}, this.defaultCascadeConfig, cascadeConfig)
        this.cascadeSelectPropList[item.id] = cascadeConfig
        if (cascadeConfig.multiple) {
          this.handleSelectFocus(item)
        }
        return cascadeConfig
      },
      contentData(data, item) {
        if (data.length > 0) {
          this.$set(this.contentMap, item.dataIndex, data)
        } else {
          this.$set(this.contentMap, item.dataIndex, item.name)
        }
      },
      searchGuide() {
        this.$emit('grid-search-guide-flag', true)
      },
      handleShowOrHideIcon() { // 如果没有部分展示按钮则点击图标可进行展示
        if (!this.showHideBtn) {
          this.showSearchForm = !this.showSearchForm
          this.emitShowSearchForm()
        }
      },
      handleShowOrHide(type) {
        if (type === '1' || type === '2') { // 收起部分 / 展开部分
          this.hideFlag = true
          this.showSearchForm = true
        } else if (type === '3') { // 收起全部
          this.hideFlag = false
          this.showSearchForm = false
        } else if (type === '4') { // 展开全部
          this.hideFlag = false
          this.showSearchForm = true
        }
        this.emitShowSearchForm()
      },
      emitShowSearchForm() {
        this.$emit('toggle-search-form', this.showSearchForm)
      },
      calculateHideCol() { // 计算部分隐藏的col
        // 默认最多展示两行检索框，部分展开时可以选择全部展开和全部收起；
        // 全部展开时可以选择部分收起和全部收起；
        // 全部收起的时候可以选择部分展开和全部展开；
        // 部分收起和部分展开即只展示两行检索框，检索框总数少于两行时不存在部分展开和部分收起；
        if (this.gridConfig.flagShowAllSearch) {
          this.emitShowSearchForm()
          return
        }
        let clearfixWidth = this.$el.querySelector('.clearfix').clientWidth
        let searchCellWidth = this.$el.querySelector('.search-cell').clientWidth
        if (searchCellWidth === 0 || clearfixWidth === 0) {
          return
        }
        // 计算每一行能展示几个搜索框
        let number = parseInt(clearfixWidth / searchCellWidth)
        let index = 1
        for (let i = 0; i < this.gridConfig.listColumnConfig.length; i++) {
          let columnConfig = this.gridConfig.listColumnConfig[i]
          if (columnConfig.search && columnConfig.type !== 'file') {
            if (index > this.hideLine * number) {
              this.$set(columnConfig, '_hide', true)
            } else {
              this.$set(columnConfig, '_hide', false)
            }
            index = index + 1
          }
        }
        let listColumnConfigs = this.gridConfig.listColumnConfig.filter(columnConfig => columnConfig.search && columnConfig.type !== 'file')
        this.showHideBtn = listColumnConfigs.length > this.hideLine * number
        this.emitShowSearchForm()
      },
      calculateHide() { // 判断默认是否显示展开部分按钮
        let clearfixWidth = this.$el.querySelector('.clearfix').clientWidth
        let searchCellWidth = this.$el.querySelector('.search-cell').clientWidth
        if (searchCellWidth === 0 || clearfixWidth === 0) {
          this.showHideBtn = false
          this.hideFlag = false
          return
        }
        // 计算每一行能展示几个搜索框
        let number = parseInt(clearfixWidth / searchCellWidth)
        let listColumnConfigs = this.gridConfig.listColumnConfig.filter(columnConfig => columnConfig.search && columnConfig.type !== 'file')
        if (listColumnConfigs.length > this.hideLine * number) {
          this.showHideBtn = true
          this.hideFlag = true
        }
      },
      searchFormAutoHeight() {
        if (this.$refs.searchForm) {
          this.searchFormHeight = this.$refs.searchForm.offsetHeight
          if (util.isIe()) {
            this.searchFormHeight = this.searchFormHeight + 8
          }
          this.$refs.whatySearchScroll.update()
        }
        setTimeout(() => {
          this.searchFormAutoHeight()
        }, 200)
      }
    }
  }
</script>
<style lang="scss">
  .whaty-grid-search-form {
    .mSearch-form-group {
      div:focus {
        outline: none;
      }
    }

    /*overflow: hidden;*/
    .el-select {
      width: 100%;
    }
    .mSearch-cell {
      width: 220px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
    /* WebKit, Blink, Edge */
    input::-webkit-input-placeholder {
      color: #aaa;
    }
    /* Mozilla Firefox 4 to 18 */
    input:-moz-placeholder {
      color: #aaa;
    }
    /* Mozilla Firefox 19+ */
    input::-moz-placeholder {
      color: #aaa;
    }
    /* Internet Explorer 10-11 */
    input:-ms-input-placeholder {
      color: #aaa;
    }
  }
  /* el-date-picker样式重置 */
  /* el-data-picker元素会添加到当前组件之外,所以这段样式不能放入'.whaty-grid-search-form'内部! */
  .whaty-el-date-picker .el-picker-panel__sidebar {
    width: 70px;
  }
  .whaty-el-date-picker .el-picker-panel__body {
    margin-left: 70px;
  }
  .whaty-el-date-picker.el-date-range-picker.has-sidebar {
    width: 582px;
  }
  .whaty-el-date-picker .el-date-range-picker__content {
    padding: 6px;
  }
  .whaty-el-date-picker .el-picker-panel__shortcut:nth-child(2n) {
    border-bottom: 1px solid rgb(228, 231, 237);
  }

  .mSearch-filter {
    .el-icon-arrow-up:before {
      color: #616365;
      content: "";
      font-size: 16px;
    }

    .el-select {
      width: 186px;

      input {
        display: block;
        width: 100%;
        height: 32px;
        padding: 0 24px 0 12px;
        font-size: 14px;
        color: #616365;
        background-color: white;
        background-image: none;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        -webkit-transition: 0.15s;
        transition: 0.15s;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &::-moz-placeholder {
          color: #313335;
        }

        &::-ms-input-placeholder {
          color: #313335;
        }

        &::-webkit-input-placeholder {
          color: #313335;
        }

      }
    }
  }

  .search-select {
    .el-select-dropdown__item {
      span {
        max-width: 140px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .search-fold-dropdown {
    .drop-list:hover {
      background-color: #f3f5f7;
      color: #616365;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/grid-search-form.vue